
export class WorkflowForm {
    id?;
    workflowStepId?;
    code?;
    serviceCode?;
    isGeneral?;
}
